module.exports = __webpack_public_path__ + "static/media/door-open.a5955e63.svg";